<template>
  <div id="wrapper" class="active">
    <main id="main-container" class="main-container">
      <div class="switch-logo">
        <a href="/software">
          <img
            src="https://switch-cn.gtgres.com/switch/aabpa/assets/images/common/logo_switch.png"
            alt="Nintendo Switch"
          />
        </a>
      </div>

      <section id="mv">
        <figure class="bg target topbg delay500">
          <picture>
            <source
              srcset="../../assets/img/top/mv--element--sp.png?imbypass=true"
              media="(max-width: 750px)"
            />
            <img
              src="../../assets/img/top/mv--element.png?imbypass=true"
              alt=""
            />
          </picture>
        </figure>

        <div class="ywrk-inner">
          <h1 class="logo target bound">
            <picture>
              <source
                srcset="../../assets/img/top/mv--logo--sp.png?imbypass=true"
                media="(max-width: 750px)"
              />
              <img
                src="../../assets/img/top/mv--logo.png?imbypass=true"
                alt=""
              />
            </picture>
          </h1>
          <div class="hakari_unit target fade">
            <div class="hakari_shadow">
              <img src="../../assets/img/top/mv--hakari_shadow.png" alt="" />
            </div>
            <div id="jsHakariAni" class="hakari type1"></div>
            <div class="sprite">
              <img
                src="../../assets/img/top/mv--hakari_sprite1.png?imbypass=true"
                alt=""
              />
              <img
                src="../../assets/img/top/mv--hakari_sprite2.png?imbypass=true"
                alt=""
              />
              <img
                src="../../assets/img/top/mv--hakari_sprite3.png?imbypass=true"
                alt=""
              />
            </div>
          </div>
          <section id="update">
            <div class="release_unit">
              <p class="release target fade action">
                2023.<span>12.21</span>(四)发售
              </p>
            </div>
            <ul>
              <li class="video target fade action">
                <a href="./movie">
                  <div class="ywrk-video_wrap">
                    <!-- <video
                      src="../../assets/mp4/mv--video.mp4"
                      poster="../../assets/img/top/mv--thum.png"
                      preload=""
                      muted=""
                      loop=""
                      playsinline=""
                      autoplay=""
                    ></video> -->
                    <img
                      src="../../assets/img/movie/thum1.png"
                      style="width: 100%;"
                    />
                  </div>
                  <div class="frame">
                    <picture>
                      <source
                        srcset="
                          ../../assets/img/top/update--video-frame--sp.png
                        "
                        media="(max-width: 750px)"
                      />
                      <img
                        src="../../assets/img/top/update--bnr-frame.png"
                        alt=""
                      />
                    </picture>
                  </div>
                  <p class="text">视频</p>
                  <div class="chara is-pc">
                    <img
                      src="../../assets/img/top/update--video-chara.png"
                      alt=""
                    />
                  </div>
                  <div class="arrow">
                    <img
                      src="../../assets/img/common/button--arrow_brown.png"
                      alt="→"
                    />
                  </div>
                  <div class="hover">
                    <img
                      src="../../assets/img/top/update--bnr-hover.png"
                      alt=""
                    />
                  </div>
                </a>
              </li>
            </ul>
          </section>
          <div class="avatar">
            <div class="avatar1 target bound">
              <picture>
                <source
                  srcset="../../assets/img/top/mv--avatar1--sp.png"
                  media="(max-width: 750px)"
                />
                <img src="../../assets/img/top/mv--avatar1.png" alt="" />
              </picture>
            </div>
            <div class="avatar2 target bound">
              <picture>
                <source
                  srcset="../../assets/img/top/mv--avatar2--sp.png"
                  media="(max-width: 750px)"
                />
                <img src="../../assets/img/top/mv--avatar2.png" alt="" />
              </picture>
            </div>
            <div class="avatar3 target bound">
              <picture>
                <source
                  srcset="../../assets/img/top/mv--avatar3--sp.png"
                  media="(max-width: 750px)"
                />
                <img src="../../assets/img/top/mv--avatar3.png" alt="" />
              </picture>
            </div>
            <div class="avatar4 target bound">
              <picture>
                <source
                  srcset="../../assets/img/top/mv--avatar4--sp.png"
                  media="(max-width: 750px)"
                />
                <img src="../../assets/img/top/mv--avatar4.png" alt="" />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section id="stretch">
        <div class="unit_cream">
          <div class="bg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="1150"
              height="2352"
              viewBox="0 0 1150 2352"
            >
              <defs>
                <pattern
                  id="svgStretchBg1"
                  x="0"
                  y="0"
                  width="751"
                  height="751"
                  patternUnits="userSpaceOnUse"
                >
                  <image
                    x="0"
                    y="0"
                    width="751"
                    height="751"
                    :xlink:href="
                      require('../../assets/img/common/bg--pattern_cream.png') +
                      '?imbypass=true'
                    "
                  />
                </pattern>
              </defs>
              <path
                fill="url(#svgStretchBg1)"
                d="M1149.707,532.933 C1149.707,569.52 1149.999,569.52 1149.999,605.170 C1149.999,629.44 1149.582,1443.196 1149.300,1526.746 C1149.316,1544.65 1149.326,1653.729 1149.326,1660.595 C1149.326,1670.638 1149.165,1835.995 1148.999,1858.222 C1148.999,1859.32 1149.45,1752.935 1149.45,1753.608 C1149.45,1789.729 1149.326,2013.663 1149.326,2049.785 C1149.326,2085.907 1147.842,2189.828 1147.842,2225.950 C1147.842,2262.74 1148.376,2262.74 1148.376,2298.197 C1148.376,2326.893 1149.999,2352.58 1101.151,2351.537 C1068.275,2351.187 1068.273,2350.743 1035.395,2350.743 C1002.518,2350.743 1002.518,2349.904 969.640,2349.904 C936.763,2349.904 936.763,2348.784 903.885,2348.784 C871.10,2348.784 871.10,2351.423 838.135,2351.423 C805.259,2351.423 805.259,2350.621 772.383,2350.621 C739.507,2350.621 739.507,2349.161 706.631,2349.161 C673.752,2349.161 673.752,2348.944 640.874,2348.944 C607.996,2348.944 607.996,2349.415 575.117,2349.415 C542.239,2349.415 542.239,2349.301 509.361,2349.301 C476.482,2349.301 476.482,2350.279 443.603,2350.279 C410.725,2350.279 410.725,2350.546 377.846,2350.546 C344.969,2350.546 344.969,2350.974 312.91,2350.974 C279.212,2350.974 279.212,2351.509 246.333,2351.509 C213.454,2351.509 213.454,2350.638 180.574,2350.638 C147.692,2350.638 147.692,2351.471 114.811,2351.471 C81.929,2351.471 81.929,2351.399 49.48,2351.399 C22.705,2351.399 0.0,2347.764 1.580,2298.197 C2.731,2262.91 1.238,2262.76 1.238,2225.956 C1.238,2189.836 1.909,2073.903 1.909,2037.783 C1.909,2035.152 0.999,1888.441 0.999,1845.219 C0.999,1809.100 1.909,1677.978 1.909,1641.857 C1.909,1640.651 1.910,1539.283 1.911,1537.826 C1.428,1441.215 0.781,627.800 0.781,605.187 C0.781,569.65 0.0,569.65 0.0,532.944 C0.0,510.249 1.45,501.21 1.822,488.340 C1.352,395.123 0.781,291.421 0.781,270.161 C0.781,234.40 0.0,234.40 0.0,197.919 C0.0,161.796 2.649,159.795 2.649,123.673 C2.649,87.549 2.519,87.549 2.519,51.426 C2.519,22.730 0.0,1.302 49.48,0.418 C81.919,0.172 81.926,0.843 114.804,0.843 C147.682,0.843 147.682,1.858 180.559,1.858 C213.436,1.858 213.436,2.375 246.314,2.375 C279.189,2.375 279.189,2.696 312.64,2.696 C344.940,2.696 344.940,0.69 377.816,0.69 C410.692,0.69 410.692,1.718 443.569,1.718 C476.447,1.718 476.447,1.140 509.325,1.140 C542.204,1.140 542.204,1.236 575.82,1.236 C607.960,1.236 607.960,0.628 640.838,0.628 C673.717,0.628 673.717,0.166 706.596,0.166 C739.474,0.166 739.474,2.423 772.353,2.423 C805.230,2.423 805.230,1.532 838.108,1.532 C870.987,1.532 870.987,0.0 903.866,0.0 C936.746,0.0 936.746,2.59 969.626,2.59 C1002.507,2.59 1002.507,2.830 1035.388,2.830 C1068.270,2.830 1068.271,2.467 1101.151,2.705 C1149.999,3.60 1147.851,24.730 1147.851,53.426 C1147.851,89.547 1148.576,89.547 1148.576,125.667 C1148.576,161.787 1149.707,161.787 1149.707,197.907 C1149.707,234.26 1149.999,234.26 1149.999,270.144 C1149.999,295.556 1149.527,415.671 1149.247,500.203 C1149.490,508.231 1149.707,517.122 1149.707,532.933 Z"
              />
            </svg>
          </div>
          <h2 class="target fade">
            <picture>
              <source
                srcset="../../assets/img/top/stretch--title--sp.png"
                media="(max-width: 750px)"
              />
              <img
                data-lazy
                :data-src="
                  require('../../assets/img/top/stretch--title.png?imbypass=true')
                "
                alt=""
              />
            </picture>
          </h2>
          <div id="jsChangeClassText" class="ywrk-text_warp target fade">
            <p>
              挑战分为5个类别的<br class="is-sp" />“大脑伸展运动”，<br />
              来提升头脑的<br class="is-sp" />“灵活度”。
            </p>
            <div class="text_warp--marks">
              <div class="text_warp--marks_item1">
                <svg
                  id="text_warp--marks_item1_svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 216 58"
                >
                  <g id="marks_item2_body" mask="url(#marks_item1_clipmask)">
                    <path
                      d="M26.1 14.4c-.9.3-2.1-.3-1.5-1.3-1.3-3.5-1.7-7-1.8-10.6 0-1.1.9-1.9 1.9-1.9 1 0 1.8.9 1.9 1.9.1 1.7.2 3.3.8 4.9.4.5-.4.8-.3 1.2 0 .2 0 .4.1.6v1c0 .2.1.4.1.6.1.4.1.8.2 1.3 0 1-.4 1.9-1.4 2.3zm-7.6 3.9c-.9.9-2 .1-2.5-.7-2-3-3.9-6-5.9-9-.6-.8-.1-2 1.1-2.6.4-.6 2 .6 2.1.7 2 3 3.9 6 5.9 9 .7.9.1 2-.7 2.6zm-8.6 3.1c1.1.1 1.7.2 2.5.2 1 .1 1.8.8 1.9 1.9 0 1-.9 2-1.9 1.9-3.5-.2-7-.7-10.4-1.5-1-.2-1.5-1.4-1.2-2.3.1-1 1.2-1.5 2.2-1.3 1.6.4 3.2.7 5.7.9-.8 0-.5.1-.4.1.2 0 .3 0 .8.1h.8z"
                    />
                    <!-- <path d="M23.9 56.5h189.5c3.2 0 3.2-4.9 0-4.9H23.9c-2.8 0-3.2 4.9 0 4.9z" /> -->
                  </g>
                  <mask id="marks_item1_clipmask" maskUnits="objectBoundingBox">
                    <path d="M22.1 54.3h194.2" />
                    <path d="M15.1 24.4L1.1 21" />
                    <path d="M18.9 18.3L10.3 5.9" />
                    <path d="M27 15.1L24.2.6" />
                  </mask>
                </svg>
              </div>
              <div class="text_warp--marks_item1-2">
                <svg
                  id="text_warp--marks_item1_2_svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 111 7"
                >
                  <g id="marks_item2_2_body">
                    <!-- <path d="M26.1 14.4c-.9.3-2.1-.3-1.5-1.3-1.3-3.5-1.7-7-1.8-10.6 0-1.1.9-1.9 1.9-1.9 1 0 1.8.9 1.9 1.9.1 1.7.2 3.3.8 4.9.4.5-.4.8-.3 1.2 0 .2 0 .4.1.6v1c0 .2.1.4.1.6.1.4.1.8.2 1.3 0 1-.4 1.9-1.4 2.3zm-7.6 3.9c-.9.9-2 .1-2.5-.7-2-3-3.9-6-5.9-9-.6-.8-.1-2 1.1-2.6.4-.6 2 .6 2.1.7 2 3 3.9 6 5.9 9 .7.9.1 2-.7 2.6zm-8.6 3.1c1.1.1 1.7.2 2.5.2 1 .1 1.8.8 1.9 1.9 0 1-.9 2-1.9 1.9-3.5-.2-7-.7-10.4-1.5-1-.2-1.5-1.4-1.2-2.3.1-1 1.2-1.5 2.2-1.3 1.6.4 3.2.7 5.7.9-.8 0-.5.1-.4.1.2 0 .3 0 .8.1h.8z" /> -->
                    <path
                      d="M3 2.5H108"
                      stroke="#FE5231"
                      stroke-width="5"
                      stroke-linecap="round"
                    />
                  </g>
                </svg>
              </div>
              <div class="text_warp--marks_item2">
                <svg
                  id="text_warp--marks_item2_svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 264 50"
                >
                  <g mask="url(#marks_item2_clipmask)">
                    <path
                      d="M1.42009 49C21.9214 48.9 42.4227 48.8 62.924 48.7C83.3032 48.6 103.682 48.5 124.062 48.6C135.96 48.3 147.065 48.2 158.536 48.1C160.488 48.1 160.488 43 158.536 43C138.034 43.1 117.533 43.4 97.1538 43.3C76.7135 43.4 56.3343 43.5 35.894 43.6C24.423 43.7 13.3182 43.7 1.42009 43.8C-0.349367 43.9 -0.59343 49 1.42009 49Z"
                      fill="black"
                    />

                    <circle cx="169" cy="3.8" r="2.5" />
                    <circle cx="195" cy="3.8" r="2.5" />
                    <circle cx="223" cy="3.8" r="2.5" />
                    <circle cx="248.6" cy="3.8" r="2.5" />
                  </g>
                  <mask id="marks_item2_clipmask" maskUnits="objectBoundingBox">
                    <line x1="0" y1="46.8" x2="262.2" y2="46.8" />
                    <line x1="139.2" y1="3.8" x2="251.1" y2="3.8" />
                  </mask>
                </svg>
              </div>
              <div id="text_warp--marks_item3" class="text_warp--marks_item3">
                <svg
                  id="text_warp--marks_item3_svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 208 60"
                >
                  <path
                    mask="url(#marks_item3_clipmask)"
                    d="M120.638 11.4099C119.07 9.48849 117.139 7.98478 115.209 6.89878C114.063 6.314 112.857 5.97985 111.65 5.56215C110.444 5.14446 109.298 4.72676 108.091 4.3926C98.4397 1.46874 88.5469 0.299191 78.6541 0.0485733C68.6407 -0.202044 58.6876 0.549808 48.7344 1.55228C43.7277 2.05351 38.721 2.47121 33.7143 3.3066C28.7076 4.14199 23.7009 5.14446 18.7545 6.56462C14.7129 7.81771 10.611 9.65557 6.99171 12.4124C4.33754 14.4173 1.2008 17.3412 0.356299 21.6017C-0.608852 26.5305 0.416621 32.1276 3.07078 35.6362C4.45819 37.4741 6.08688 38.4765 7.77589 39.6461C9.52522 40.8156 11.3349 41.9016 13.1445 42.737C22.5548 47.1646 32.6888 47.9165 42.5213 48H49.8202C50.3631 48 50.7251 47.6658 50.9664 47.1646C59.1098 46.9975 67.3136 46.6634 75.457 45.828C85.2895 44.8255 95.1823 43.0712 104.773 39.7296C109.056 38.2259 113.399 36.7222 117.441 34.2161C120.819 32.1276 123.292 28.2848 123.896 23.1054C124.378 18.6778 123.172 14.4173 120.638 11.4099ZM120.759 23.2724C120.397 25.4444 119.613 27.2823 118.346 28.7025C117.26 29.9556 115.873 30.7909 114.485 31.3757C112.434 32.3782 110.383 33.2971 108.332 34.049C90.2359 41.2333 71.2948 42.4864 52.5347 42.9877C50.3028 43.0712 48.0106 43.0712 45.7787 43.1547C45.2961 43.1547 44.9342 43.4889 44.6929 43.823C36.9114 43.823 29.1298 43.5724 21.469 41.4839C17.4877 40.3979 13.4461 38.8107 9.70619 36.3881C8.19814 35.3856 6.56945 34.5502 5.36301 32.963C4.27722 31.6263 3.55336 30.0391 3.19143 28.0342C3.01046 27.0317 2.95014 25.9457 3.01046 24.9432C3.01046 24.3584 3.07078 23.8572 3.13111 23.2724C3.13111 23.1054 3.19143 22.9383 3.19143 22.7712C3.19143 22.6877 3.31207 22.3535 3.31207 22.27C3.79465 20.6827 4.63915 19.5967 5.72495 18.4272C8.49975 15.4198 12.0587 13.5819 15.4368 12.1617C19.7196 10.3239 24.1231 9.48849 28.5266 8.56956C33.3524 7.56709 38.1781 6.89878 43.0642 6.39754C61.8846 4.47614 80.9463 2.72182 99.6461 6.64816C104.291 7.65063 108.936 8.98725 113.46 10.658C115.209 11.3263 116.958 12.663 118.406 14.2502C118.889 14.835 119.492 15.5868 119.794 16.2552C120.216 17.007 120.517 17.9259 120.698 18.5942C121.06 20.0979 121.06 21.6017 120.759 23.2724Z"
                  />

                  <mask id="marks_item3_clipmask" maskUnits="objectBoundingBox">
                    <path
                      d="M49.37 43.9494C21.663 44.619 10.652 38.4245 10.652 38.4245C8.55747 36.2481 0 33.402 0 23.9428C0 22.5197 0.418897 18.7528 3.05197 15.0696C5.74488 11.4701 12.0882 8.37282 16.337 6.86605C20.526 5.35927 27.5874 3.35024 32.9134 3.09912C41.5905 2.68057 58.4063 -0.0818461 66.2456 0.00186338C74.085 0.0855729 90.781 0.504121 98.7401 2.9317C101.253 3.68508 110.17 4.85702 112.085 6.78234C114.957 9.62846 117.351 8.37282 119.027 13.4791C119.984 16.3252 121.6 25.1147 115.975 29.1328C110.11 33.3183 98.9196 37.5037 95.9275 37.8386C92.9354 38.2571 82.5228 40.601 82.5228 40.601L59.8425 43.0286L41.2913 42.5263H42.0094"
                    ></path>
                  </mask>
                </svg>
              </div>
            </div>
          </div>
          <div class="genre target fade">
            <nav>
              <ul>
                <li v-for="(tab, index) in tabs" :key="index">
                  <button
                    :class="{ 'is-active': currentTab === index }"
                    :data-id="'genre' + (index + 1)"
                    @click="tabClickHandler(index)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="172px"
                      height="152px"
                      viewBox="0 0 172 152"
                    >
                      <path :d="tab.bgPath" />
                    </svg>
                    <span class="icon"
                      ><img data-lazy :data-src="tab.iconPic"
                    /></span>
                    <span class="normal"
                      ><img data-lazy :data-src="tab.titleNormalPic"
                    /></span>
                    <span class="active"
                      ><img data-lazy :data-src="tab.titleActivePic"
                    /></span>
                  </button>
                </li>
              </ul>
            </nav>

            <div class="tab">
              <section
                v-for="(tab, index) in tabs"
                :id="'genre' + (index + 1)"
                :key="index"
                :class="{
                  'is-active': currentTab === index,
                  'is-open': currentTab === index
                }"
              >
                <div class="bg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="1021"
                    height="938"
                    viewBox="0 0 1021 938"
                  >
                    <defs>
                      <pattern
                        :id="`svgStretchGenre${index + 1}Bg`"
                        x="0"
                        y="0"
                        width="376"
                        height="376"
                        patternUnits="userSpaceOnUse"
                      >
                        <image
                          x="0"
                          y="0"
                          width="376"
                          height="376"
                          :xlink:href="tab.mainBgPic"
                        />
                      </pattern>
                    </defs>
                    <path
                      :fill="`url(#svgStretchGenre${index + 1}Bg)`"
                      :d="tab.mainBgPath"
                    />
                    <rect
                      class="svgStretchGenreBgMask"
                      x="0"
                      y="758"
                      width="100%"
                      height="180"
                      clip-path="url(#svgStretchGenreBgMask)"
                    />
                  </svg>
                </div>
                <h3 :data-id="'genre' + (index + 1)">
                  <picture>
                    <source
                      :srcset="tab.mainTitleSpPic"
                      media="(max-width: 750px)"
                    />
                    <img data-lazy :data-src="tab.mainTitlePic" />
                  </picture>
                </h3>
                <div
                  class="wrap"
                  :style="{ display: currentTab === index ? 'block' : 'none' }"
                >
                  <div class="swiper main">
                    <swiper
                      :ref="'mainSwiper' + (index + 1)"
                      class="swiper-wrapper"
                      :options="swiperMainOption"
                    >
                      <swiper-slide
                        v-for="(content, i) in tab.contents"
                        :key="i"
                        class="swiper-slide"
                      >
                        <div
                          class="unit"
                          data-ytplayer
                          :data-ytid="content.vid"
                        >
                          <tx-video
                            :container-id="
                              'genre_video_' + (index + 1) + '_' + (i + 1)
                            "
                            :vid="content.vid"
                            class="yt"
                          ></tx-video>
                          <button
                            :class="{
                              'is-playing':
                                currentPlaying ===
                                'genre_video_' + (index + 1) + '_' + (i + 1)
                            }"
                            @click="
                              playVideo(
                                'genre_video_' + (index + 1) + '_' + (i + 1)
                              )
                            "
                          >
                            <picture>
                              <source
                                :srcset="content.picSp"
                                media="(max-width: 750px)"
                              />
                              <img data-lazy :data-src="content.pic" alt="" />
                            </picture>
                            <span class="icon"
                              ><img
                                src="../../assets/img/common/button--play.png"
                                alt=""
                            /></span>
                          </button>
                        </div>
                        <p>{{ content.desc }}</p>
                      </swiper-slide>
                    </swiper>
                    <div
                      v-show="currentMainIndex >= 1"
                      class="swiper-button-prev"
                      @click="swiperPrev(index)"
                    >
                      <img
                        data-lazy
                        :data-src="
                          require('../../assets/img/top/stretch--arrow_left.png')
                        "
                        alt="←"
                      />
                    </div>
                    <div
                      v-show="currentMainIndex < tab.contents.length - 1"
                      class="swiper-button-next"
                      @click="swiperNext(index)"
                    >
                      <img
                        data-lazy
                        :data-src="
                          require('../../assets/img/top/stretch--arrow_right.png')
                        "
                        alt="→"
                      />
                    </div>
                  </div>
                </div>
                <div thumbsSlider="" class="swiper thumbnail">
                  <swiper
                    :ref="'thumbSwiper' + (index + 1)"
                    class="swiper-wrapper swiper-overflow-visible swiper-container-thumbs"
                    :options="swiperThumbOption"
                  >
                    <swiper-slide
                      v-for="(thumb, j) in tab.contents"
                      :key="j"
                      class="swiper-slide"
                      :class="{
                        'swiper-slide-thumb-active': currentMainIndex === j
                      }"
                      @click.native="thumbSwiperChangeHandler(index, j)"
                    >
                      <figure>
                        <img data-lazy :data-src="thumb.thumbPic" alt="" />
                      </figure>
                    </swiper-slide>
                  </swiper>
                </div>
                <button
                  class="close is-sp"
                  :data-id="'genre' + (index + 1)"
                ></button>
              </section>
            </div>
          </div>

          <div class="test">
            <h3 class="target bound">
              <img
                data-lazy
                :data-src="
                  require('../../assets/img/top/stretch--subtitle.png')
                "
                alt=""
              />
            </h3>
            <figure class="ywrk-frame_brown target fade">
              <picture>
                <source
                  srcset="../../assets/img/top/stretch--img1--sp.png"
                  media="(max-width: 750px)"
                />
                <img
                  data-lazy
                  :data-src="require('../../assets/img/top/stretch--img1.png')"
                  alt=""
                />
              </picture>
            </figure>
            <p class="text target fade textline">
              通过“测试”还可以分析出<br class="is-sp" />综合的<span
                >“灵活度”</span
              >
            </p>
            <p class="target fade">
              <a class="ywrk-button_yellow" href="./stretch/"
                >了解更多<span class="arrow"
                  ><img
                    data-lazy
                    :data-src="
                      require('../../assets/img/common/button--arrow_brown.png')
                    "
                    alt="→" /></span
              ></a>
            </p>
          </div>
        </div>
      </section>

      <section id="match">
        <div class="ywrk-inner">
          <div class="avatar target bound">
            <img
              data-lazy
              :data-src="require('../../assets/img/top/match--avatar1.png')"
              alt=""
            />
          </div>
          <h2 class="target fade">
            <img
              data-lazy
              :data-src="
                require('../../assets/img/top/match--title.png?imbypass=true')
              "
              alt=""
            />
          </h2>
          <p class="lead target fade">
            不论年龄段，大家都能<br />
            一起伸展大脑。
          </p>

          <div id="jsChangeClassBgPc" class="bg target is-pc">
            <div class="type1">
              <div class="obj1">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type1_img1.png')
                  "
                  alt=""
                />
              </div>
              <div class="obj3">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type1_img3.png')
                  "
                  alt=""
                />
              </div>
              <div class="obj5">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type1_img5.png')
                  "
                  alt=""
                />
              </div>
              <div class="obj6">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type1_img6.png')
                  "
                  alt=""
                />
              </div>
              <div class="obj8">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type1_img8.png')
                  "
                  alt=""
                />
              </div>
            </div>
            <div class="type2">
              <div class="obj2">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type2_img2.png')
                  "
                  alt=""
                />
              </div>
              <div class="obj5">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type2_img5.png')
                  "
                  alt=""
                />
              </div>
              <div class="obj6">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type2_img6.png')
                  "
                  alt=""
                />
              </div>
              <div class="obj8">
                <img
                  data-lazy
                  :data-src="
                    require('../../assets/img/top/match--type2_img8.png')
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
          <div id="jsChangeClassBgSp" class="bg target is-sp">
            <div class="obj1">
              <svg
                id="svgObj1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="268"
                height="270"
                viewBox="-6 -6 276 278"
              >
                <defs>
                  <pattern
                    id="svgObj1Anime"
                    x="0"
                    y="0"
                    width="268"
                    height="270"
                    patternUnits="userSpaceOnUse"
                  >
                    <image
                      x="0"
                      y="0"
                      width="100%"
                      height="100%"
                      preserveAspectRatio="xMinYMin slice"
                      :xlink:href="
                        require('../../assets/img/top/match--type1_img1--sp.png')
                      "
                    />
                  </pattern>
                </defs>
                <path
                  fill="url(#svgObj1Anime)"
                  d="M259.75,131.26 C259.75,144.905 256.874,158.627 252.784,171.191 C248.590,184.177 240.726,195.480 232.862,206.310 C224.945,217.245 215.928,227.287 205.23,235.278 C194.223,243.164 182.217,249.578 169.267,253.784 C156.789,257.832 143.368,261.39 129.527,261.39 C115.686,261.39 102.160,258.147 89.682,254.99 C76.732,249.893 65.565,242.112 54.818,234.226 C43.913,226.288 34.161,217.245 26.245,206.363 C18.381,195.533 10.621,184.230 6.427,171.191 C2.390,158.679 0.922,144.958 0.922,131.78 C0.922,117.199 3.334,103.793 7.371,91.281 C11.565,78.295 17.437,65.940 25.301,55.110 C33.218,44.175 42.497,33.871 53.402,25.932 C64.202,18.47 77.257,13.788 90.206,9.530 C102.684,5.482 115.739,0.960 129.579,0.960 C143.420,0.960 157.51,3.642 169.529,7.690 C182.479,11.895 193.646,19.834 204.446,27.720 C215.351,35.658 226.151,44.18 234.68,54.953 C241.932,65.783 246.545,78.611 250.739,91.596 C254.776,104.56 259.75,117.146 259.75,131.26 L259.75,131.26 Z"
                />
              </svg>
            </div>
            <div class="obj3">
              <img
                data-lazy
                :data-src="
                  require('../../assets/img/top/match--type1_img3--sp.png')
                "
                alt=""
              />
            </div>
            <div class="obj4">
              <img
                data-lazy
                :data-src="
                  require('../../assets/img/top/match--type1_img4--sp.png')
                "
                alt=""
              />
            </div>
            <div class="obj6">
              <svg
                id="svgObj6"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="250"
                height="250"
                viewBox="-4 -4 258 258"
              >
                <defs>
                  <pattern
                    id="svgObj6Anime"
                    x="0"
                    y="0"
                    width="250"
                    height="250"
                    patternUnits="userSpaceOnUse"
                  >
                    <image
                      x="0"
                      y="0"
                      width="100%"
                      height="100%"
                      preserveAspectRatio="xMinYMin slice"
                      :xlink:href="
                        require('../../assets/img/top/match--type1_img6--sp.png')
                      "
                    />
                  </pattern>
                </defs>
                <path
                  fill="url(#svgObj6Anime)"
                  d="M150.409,7.40 C182.786,14.353 207.288,36.317 223.710,62.318 C240.131,88.318 249.151,119.811 241.833,152.170 C234.515,184.530 214.280,211.394 188.267,227.808 C162.254,244.220 129.849,248.443 97.472,241.127 C65.96,233.813 37.174,216.378 20.752,190.377 C4.331,164.377 0.419,131.645 7.737,99.285 C15.55,66.926 33.823,40.879 59.836,24.467 C85.849,8.51 118.33,0.274 150.409,7.40 Z"
                />
              </svg>
            </div>
          </div>

          <div class="class">
            <div class="column">
              <figure class="target fade">
                <figcaption>
                  <img
                    data-lazy
                    :data-src="require('../../assets/img/match/subtitle1.png')"
                    alt=""
                  />
                </figcaption>
                <div class="unit_video">
                  <div
                    class="ywrk-video_wrap"
                    data-ytplayer
                    data-type="autoplay"
                    data-ytid="heciiEA2p34"
                  >
                    <tx-video
                      :container-id="'unit_video_1'"
                      :vid="'w3529d5iub2'"
                      :autoplay="true"
                      :mute="true"
                      :loop="true"
                      :no-control="true"
                      class="yt"
                    ></tx-video>
                  </div>
                </div>
              </figure>
              <figure class="target fade">
                <figcaption>
                  <img
                    data-lazy
                    :data-src="require('../../assets/img/match/subtitle2.png')"
                    alt=""
                  />
                </figcaption>
                <div class="unit_video">
                  <div
                    class="ywrk-video_wrap"
                    data-ytplayer
                    data-type="autoplay"
                    data-ytid="1vKdDpllkDo"
                  >
                    <tx-video
                      :container-id="'unit_video_2'"
                      :vid="'a35295w3ncv'"
                      :autoplay="true"
                      :mute="true"
                      :loop="true"
                      :no-control="true"
                      class="yt"
                    ></tx-video>
                  </div>
                </div>
              </figure>
              <div class="hakari target bound is-pc">
                <img
                  data-lazy
                  :data-src="require('../../assets/img/top/match--hakari.png')"
                  alt=""
                />
              </div>
            </div>
            <p class="text target fade">
              从“幼儿”到“超级精英”，<br
                class="is-sp"
              />能够设置6个层级的难度。<br />
              还配备有较低年龄儿童<br class="is-sp" />也能游玩的辅助功能，<br />
              不论是小孩还是对实力充满自信的成人，<br
                class="is-sp"
              />都可以尽情畅玩。
            </p>
            <div class="kata target bound">
              <div class="img1">
                <img
                  data-lazy
                  :data-src="require('../../assets/img/top/match--kata1.png')"
                  alt=""
                />
              </div>
              <div class="img2">
                <img
                  data-lazy
                  :data-src="require('../../assets/img/top/match--kata2.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
          <p class="target fade">
            <a class="ywrk-button_yellow" href="./match/"
              >了解更多<span class="arrow"
                ><img
                  data-lazy
                  :data-src="
                    require('../../assets/img/common/button--arrow_brown.png')
                  "
                  alt="→" /></span
            ></a>
          </p>
        </div>
      </section>

      <section id="product">
        <div class="ywrk-inner">
          <div class="column target fade">
            <div class="product">
              <div class="img">
                <figure>
                  <img
                    data-lazy
                    :data-src="
                      require('../../assets/img/top/product--package.png')
                    "
                    alt=""
                  />
                </figure>
              </div>
              <dl>
                <dt>灵活脑学校</dt>
                <dd>
                  <ul>
                    <li>发售日：2023年12月21日（四）</li>
                    <li>支持中文</li>
                    <li>盒装版/下载版</li>
                  </ul>
                </dd>
              </dl>
            </div>
            <buy-button :urls="buyLinkList"></buy-button>
          </div>
        </div>
      </section>
    </main>
    <page-footer></page-footer>
  </div>
</template>

<script>
import '../../assets/css/buy-now.css';
import '../../assets/css/common.css';
import '../../assets/css/top.css';
import pageFooter from '../components/page-footer';
import $ from 'jquery';
import { checkWeixinBrowser, buyLinkList } from '../api';
import buyButton from '../components/buy-btn';
import txVideo from '../components/tx-video';
import { lazyLoadImage, targetDelay } from '../lazyLoad';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  components: {
    pageFooter,
    buyButton,
    swiper,
    swiperSlide,
    txVideo
  },
  data() {
    return {
      buyLinkList,
      currentTab: 0,
      currentPlaying: '',
      currentMainIndex: 0,
      tabs: [
        {
          bgPath:
            'M156.265,0.588 C154.884,0.588 133.382,0.11 99.309,0.12 C93.950,0.12 81.208,0.944 75.873,0.946 C43.73,0.957 21.435,0.50 16.810,0.134 C12.829,0.204 8.768,0.765 6.271,0.947 C3.1,1.185 0.343,5.134 0.343,10.299 C0.343,10.299 0.182,31.113 0.13,46.176 C0.61,52.928 0.132,77.16 0.319,92.881 C0.452,104.64 0.504,105.562 0.407,117.869 C0.351,125.80 0.343,140.984 0.343,140.984 C0.343,146.149 2.997,150.336 6.271,150.336 C8.134,150.336 13.136,150.987 14.836,150.987 C17.538,150.987 27.930,150.780 45.809,150.787 C65.472,150.794 88.593,149.924 110.435,149.919 C135.82,149.911 147.809,150.983 154.914,150.983 C157.861,150.983 163.689,150.336 165.845,150.336 C169.119,150.336 171.773,146.149 171.773,140.984 L171.938,136.169 C171.938,136.169 171.663,124.643 171.810,121.290 C171.958,117.935 171.364,99.615 171.521,81.535 C171.734,57.103 171.945,38.214 171.985,34.926 C172.40,30.330 172.59,17.537 171.773,10.299 C171.773,5.134 169.119,0.947 165.845,0.947 C163.571,0.947 157.861,0.588 156.265,0.588 Z',
          iconPic: require('../../assets/img/top/stretch--genre1_tab-icon.png'),
          titleNormalPic: require('../../assets/img/top/stretch--genre1_tab-normal.png'),
          titleActivePic: require('../../assets/img/top/stretch--genre1_tab-active.png'),
          mainBgPic: require('../../assets/img/common/bg--pattern_genre1.png'),
          mainBgPath:
            'M1018.974,569.197 C1018.879,488.358 1019.642,330.217 1019.974,264.724 C1020.441,172.709 1020.6,134.79 1019.974,127.836 C1019.752,85.295 1019.985,37.292 1019.985,37.292 C1019.985,22.198 1005.926,4.502 995.999,4.502 C995.999,4.502 957.692,2.4 907.796,2.909 C874.325,3.515 809.438,4.231 780.821,4.639 C780.536,4.617 780.255,4.572 779.967,4.572 C779.967,4.572 739.420,2.421 694.260,2.752 L591.863,3.418 L481.367,1.959 L359.931,0.500 L259.938,0.486 L127.573,0.794 L28.751,0.584 C9.371,0.584 0.0,8.656 0.928,32.289 C2.26,50.323 0.857,73.621 1.509,91.688 C2.282,113.94 1.648,179.832 1.517,202.409 C0.921,305.523 1.842,410.810 2.116,458.570 C2.483,522.855 1.334,535.597 1.333,612.174 C1.333,621.900 2.426,657.902 1.691,721.19 C1.131,768.981 0.10,894.89 0.10,894.89 C0.10,909.181 6.518,935.664 31.863,935.664 C31.863,935.664 91.932,935.617 107.970,935.617 C175.864,935.617 287.271,935.664 237.992,935.664 C237.992,935.664 263.702,935.646 286.626,935.631 C314.641,936.606 363.300,936.685 377.645,937.275 C400.812,938.227 478.983,937.597 511.59,936.695 C513.800,936.617 640.946,935.271 644.185,935.249 C676.840,936.235 710.956,935.823 727.278,936.494 C750.444,937.446 813.213,935.934 845.297,936.526 C908.859,937.691 1015.147,935.931 984.688,935.931 C1013.832,935.931 1018.985,919.366 1018.985,898.74 L1018.560,851.585 C1019.70,840.685 1019.876,799.484 1019.974,679.210 C1020.33,605.309 1019.71,651.717 1018.974,569.197 Z',
          mainTitleSpPic: require('../../assets/img/top/stretch--genre1_title--sp.png'),
          mainTitlePic: require('../../assets/img/top/stretch--genre1_title.png'),
          contents: [
            {
              vid: 'j35297sufso',
              picSp: require('../../assets/img/top/stretch--genre1-img1--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre1-img1.jpg'),
              desc: '「配图鼹鼠」',
              thumbPic: require('../../assets/img/top/stretch--genre1-thum1.jpg')
            },
            {
              vid: 'x35296endp5',
              picSp: require('../../assets/img/top/stretch--genre1-img2--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre1-img2.jpg'),
              desc: '「动物照灯」',
              thumbPic: require('../../assets/img/top/stretch--genre1-thum2.jpg')
            },
            {
              vid: 'c3529gd0cz5',
              picSp: require('../../assets/img/top/stretch--genre1-img3--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre1-img3.jpg'),
              desc: '「剪裁艺术」',
              thumbPic: require('../../assets/img/top/stretch--genre1-thum3.jpg')
            },
            {
              vid: 'p3529iv7o4f',
              picSp: require('../../assets/img/top/stretch--genre1-img4--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre1-img4.jpg'),
              desc: '「照片推理」',
              thumbPic: require('../../assets/img/top/stretch--genre1-thum4.jpg')
            }
          ]
        },
        {
          bgPath:
            'M156.265,0.588 C154.884,0.588 133.382,0.11 99.309,0.12 C93.950,0.12 81.208,0.944 75.873,0.946 C43.73,0.957 21.435,0.50 16.810,0.134 C12.829,0.204 8.768,0.765 6.271,0.947 C3.1,1.185 0.343,5.134 0.343,10.299 C0.343,10.299 0.182,31.113 0.13,46.176 C0.61,52.928 0.131,77.16 0.319,92.881 C0.452,104.64 0.504,105.562 0.407,117.869 C0.351,125.80 0.343,140.984 0.343,140.984 C0.343,146.149 2.997,150.336 6.271,150.336 C8.133,150.336 13.136,150.987 14.836,150.987 C17.538,150.987 27.930,150.780 45.809,150.787 C65.472,150.794 88.593,149.924 110.435,149.919 C135.83,149.911 147.809,150.983 154.914,150.983 C157.861,150.983 163.689,150.336 165.845,150.336 C169.119,150.336 171.774,146.149 171.774,140.984 L171.938,136.169 C171.938,136.169 171.663,124.643 171.810,121.290 C171.958,117.935 171.364,99.615 171.521,81.535 C171.734,57.103 171.945,38.214 171.985,34.926 C172.40,30.330 172.59,17.537 171.774,10.299 C171.774,5.134 169.119,0.947 165.845,0.947 C163.571,0.947 157.862,0.588 156.265,0.588 Z',
          iconPic: require('../../assets/img/top/stretch--genre2_tab-icon.png'),
          titleNormalPic: require('../../assets/img/top/stretch--genre2_tab-normal.png'),
          titleActivePic: require('../../assets/img/top/stretch--genre2_tab-active.png'),
          mainBgPic: require('../../assets/img/common/bg--pattern_genre2.png'),
          mainBgPath:
            'M1018.974,569.197 C1018.879,488.358 1019.642,330.217 1019.974,264.724 C1020.441,172.709 1020.6,134.79 1019.974,127.836 C1019.752,85.295 1019.985,37.292 1019.985,37.292 C1019.985,22.198 1005.926,4.502 995.999,4.502 C995.999,4.502 957.692,2.4 907.796,2.909 C874.325,3.515 809.438,4.231 780.821,4.639 C780.536,4.617 780.255,4.572 779.967,4.572 C779.967,4.572 739.420,2.421 694.260,2.752 L591.863,3.418 L481.367,1.959 L359.931,0.500 L259.938,0.486 L127.573,0.794 L28.751,0.584 C9.371,0.584 0.0,8.656 0.928,32.289 C2.26,50.323 0.857,73.621 1.509,91.688 C2.282,113.94 1.648,179.832 1.517,202.409 C0.921,305.523 1.842,410.810 2.116,458.570 C2.483,522.855 1.334,535.597 1.333,612.174 C1.333,621.900 2.426,657.902 1.691,721.19 C1.131,768.981 0.10,894.89 0.10,894.89 C0.10,909.181 6.518,935.664 31.863,935.664 C31.863,935.664 91.932,935.617 107.970,935.617 C175.864,935.617 287.271,935.664 237.992,935.664 C237.992,935.664 263.702,935.646 286.626,935.631 C314.641,936.606 363.300,936.685 377.645,937.275 C400.812,938.227 478.983,937.597 511.59,936.695 C513.800,936.617 640.946,935.271 644.185,935.249 C676.840,936.235 710.956,935.823 727.278,936.494 C750.444,937.446 813.213,935.934 845.297,936.526 C908.859,937.691 1015.147,935.931 984.688,935.931 C1013.832,935.931 1018.985,919.366 1018.985,898.74 L1018.560,851.585 C1019.70,840.685 1019.876,799.484 1019.974,679.210 C1020.33,605.309 1019.71,651.717 1018.974,569.197 Z',
          mainTitleSpPic: require('../../assets/img/top/stretch--genre2_title--sp.png'),
          mainTitlePic: require('../../assets/img/top/stretch--genre2_title.png'),
          contents: [
            {
              vid: 'j3529xu00ua',
              picSp: require('../../assets/img/top/stretch--genre2-img1--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre2-img1.jpg'),
              desc: '「快闪记忆」',
              thumbPic: require('../../assets/img/top/stretch--genre2-thum1.jpg')
            },
            {
              vid: 'e35293z8v0l',
              picSp: require('../../assets/img/top/stretch--genre2-img2--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre2-img2.jpg'),
              desc: '「卡片记忆」',
              thumbPic: require('../../assets/img/top/stretch--genre2-thum2.jpg')
            },
            {
              vid: 'v3529meqvrg',
              picSp: require('../../assets/img/top/stretch--genre2-img3--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre2-img3.jpg'),
              desc: '「逆向记忆」',
              thumbPic: require('../../assets/img/top/stretch--genre2-thum3.jpg')
            },
            {
              vid: 'z35295suq7a',
              picSp: require('../../assets/img/top/stretch--genre2-img4--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre2-img4.jpg'),
              desc: '「鸟笼洗牌」',
              thumbPic: require('../../assets/img/top/stretch--genre2-thum4.jpg')
            }
          ]
        },
        {
          bgPath:
            'M156.265,0.588 C154.885,0.588 133.382,0.11 99.309,0.12 C93.950,0.12 81.208,0.944 75.873,0.946 C43.73,0.957 21.435,0.50 16.810,0.134 C12.829,0.204 8.768,0.765 6.271,0.947 C3.1,1.185 0.343,5.134 0.343,10.299 C0.343,10.299 0.182,31.113 0.13,46.176 C0.61,52.928 0.131,77.16 0.319,92.881 C0.452,104.64 0.504,105.562 0.407,117.869 C0.351,125.80 0.343,140.984 0.343,140.984 C0.343,146.149 2.997,150.336 6.271,150.336 C8.133,150.336 13.136,150.987 14.836,150.987 C17.538,150.987 27.930,150.780 45.809,150.787 C65.472,150.794 88.593,149.924 110.435,149.919 C135.83,149.911 147.809,150.983 154.914,150.983 C157.861,150.983 163.689,150.336 165.845,150.336 C169.119,150.336 171.773,146.149 171.773,140.984 L171.938,136.169 C171.938,136.169 171.663,124.643 171.810,121.290 C171.957,117.935 171.364,99.615 171.521,81.535 C171.734,57.103 171.945,38.214 171.985,34.926 C172.40,30.330 172.59,17.537 171.773,10.299 C171.773,5.134 169.119,0.947 165.845,0.947 C163.571,0.947 157.862,0.588 156.265,0.588 Z',
          iconPic: require('../../assets/img/top/stretch--genre3_tab-icon.png'),
          titleNormalPic: require('../../assets/img/top/stretch--genre3_tab-normal.png'),
          titleActivePic: require('../../assets/img/top/stretch--genre3_tab-active.png'),
          mainBgPic: require('../../assets/img/common/bg--pattern_genre3.png'),
          mainBgPath:
            'M1018.974,569.197 C1018.879,488.358 1019.642,330.217 1019.974,264.724 C1020.441,172.709 1020.6,134.79 1019.974,127.836 C1019.752,85.295 1019.985,37.292 1019.985,37.292 C1019.985,22.198 1005.926,4.502 995.999,4.502 C995.999,4.502 957.692,2.4 907.796,2.909 C874.325,3.515 809.438,4.231 780.821,4.639 C780.536,4.617 780.255,4.572 779.967,4.572 C779.967,4.572 739.420,2.421 694.260,2.752 L591.863,3.418 L481.367,1.959 L359.931,0.500 L259.938,0.486 L127.573,0.794 L28.751,0.584 C9.371,0.584 0.0,8.656 0.928,32.289 C2.26,50.323 0.857,73.621 1.509,91.688 C2.282,113.94 1.648,179.832 1.517,202.409 C0.921,305.523 1.842,410.810 2.116,458.570 C2.483,522.855 1.334,535.597 1.333,612.174 C1.333,621.900 2.426,657.902 1.691,721.19 C1.131,768.981 0.10,894.89 0.10,894.89 C0.10,909.181 6.518,935.664 31.863,935.664 C31.863,935.664 91.932,935.617 107.970,935.617 C175.864,935.617 287.271,935.664 237.992,935.664 C237.992,935.664 263.702,935.646 286.626,935.631 C314.641,936.606 363.300,936.685 377.645,937.275 C400.812,938.227 478.983,937.597 511.59,936.695 C513.800,936.617 640.946,935.271 644.185,935.249 C676.840,936.235 710.956,935.823 727.278,936.494 C750.444,937.446 813.213,935.934 845.297,936.526 C908.859,937.691 1015.147,935.931 984.688,935.931 C1013.832,935.931 1018.985,919.366 1018.985,898.74 L1018.560,851.585 C1019.70,840.685 1019.876,799.484 1019.974,679.210 C1020.33,605.309 1019.71,651.717 1018.974,569.197 Z',
          mainTitleSpPic: require('../../assets/img/top/stretch--genre3_title--sp.png'),
          mainTitlePic: require('../../assets/img/top/stretch--genre3_title.png'),
          contents: [
            {
              vid: 's35296q87jr',
              picSp: require('../../assets/img/top/stretch--genre3-img1--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre3-img1.jpg'),
              desc: '「积木计算」',
              thumbPic: require('../../assets/img/top/stretch--genre3-thum1.jpg')
            },
            {
              vid: 'd3529fidkys',
              picSp: require('../../assets/img/top/stretch--genre3-img2--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre3-img2.jpg'),
              desc: '「重量比较」',
              thumbPic: require('../../assets/img/top/stretch--genre3-thum2.jpg')
            },
            {
              vid: 'g35295sposf',
              picSp: require('../../assets/img/top/stretch--genre3-img3--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre3-img3.jpg'),
              desc: '「方块塑形」',
              thumbPic: require('../../assets/img/top/stretch--genre3-thum3.jpg')
            },
            {
              vid: 'u3529r4efxu',
              picSp: require('../../assets/img/top/stretch--genre3-img4--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre3-img4.jpg'),
              desc: '「谜题快答」',
              thumbPic: require('../../assets/img/top/stretch--genre3-thum4.jpg')
            }
          ]
        },
        {
          bgPath:
            'M156.265,0.588 C154.884,0.588 133.382,0.11 99.309,0.12 C93.950,0.12 81.208,0.944 75.873,0.946 C43.73,0.957 21.435,0.50 16.810,0.134 C12.829,0.204 8.768,0.765 6.271,0.947 C3.1,1.185 0.343,5.134 0.343,10.299 C0.343,10.299 0.182,31.113 0.13,46.176 C0.61,52.928 0.132,77.16 0.319,92.881 C0.452,104.64 0.504,105.562 0.407,117.869 C0.351,125.80 0.343,140.984 0.343,140.984 C0.343,146.149 2.997,150.336 6.271,150.336 C8.134,150.336 13.136,150.987 14.836,150.987 C17.538,150.987 27.930,150.780 45.809,150.787 C65.472,150.794 88.593,149.924 110.435,149.919 C135.82,149.911 147.809,150.983 154.914,150.983 C157.861,150.983 163.689,150.336 165.845,150.336 C169.119,150.336 171.773,146.149 171.773,140.984 L171.938,136.169 C171.938,136.169 171.663,124.643 171.810,121.290 C171.958,117.935 171.364,99.615 171.521,81.535 C171.734,57.103 171.945,38.214 171.985,34.926 C172.40,30.330 172.59,17.537 171.773,10.299 C171.773,5.134 169.119,0.947 165.845,0.947 C163.571,0.947 157.861,0.588 156.265,0.588 Z',
          iconPic: require('../../assets/img/top/stretch--genre4_tab-icon.png'),
          titleNormalPic: require('../../assets/img/top/stretch--genre4_tab-normal.png'),
          titleActivePic: require('../../assets/img/top/stretch--genre4_tab-active.png'),
          mainBgPic: require('../../assets/img/common/bg--pattern_genre4.png'),
          mainBgPath:
            'M1018.974,569.197 C1018.879,488.358 1019.642,330.217 1019.974,264.724 C1020.441,172.709 1020.6,134.79 1019.974,127.836 C1019.752,85.295 1019.985,37.292 1019.985,37.292 C1019.985,22.198 1005.926,4.502 995.999,4.502 C995.999,4.502 957.692,2.4 907.796,2.909 C874.325,3.515 809.438,4.231 780.821,4.639 C780.536,4.617 780.255,4.572 779.967,4.572 C779.967,4.572 739.420,2.421 694.260,2.752 L591.863,3.418 L481.367,1.959 L359.931,0.500 L259.938,0.486 L127.573,0.794 L28.751,0.584 C9.371,0.584 0.0,8.656 0.928,32.289 C2.26,50.323 0.857,73.621 1.509,91.688 C2.282,113.94 1.648,179.832 1.517,202.409 C0.921,305.523 1.842,410.810 2.116,458.570 C2.483,522.855 1.334,535.597 1.333,612.174 C1.333,621.900 2.426,657.902 1.691,721.19 C1.131,768.981 0.10,894.89 0.10,894.89 C0.10,909.181 6.518,935.664 31.863,935.664 C31.863,935.664 91.932,935.617 107.970,935.617 C175.864,935.617 287.271,935.664 237.992,935.664 C237.992,935.664 263.702,935.646 286.626,935.631 C314.641,936.606 363.300,936.685 377.645,937.275 C400.812,938.227 478.983,937.597 511.59,936.695 C513.800,936.617 640.946,935.271 644.185,935.249 C676.840,936.235 710.956,935.823 727.278,936.494 C750.444,937.446 813.213,935.934 845.297,936.526 C908.859,937.691 1015.147,935.931 984.688,935.931 C1013.832,935.931 1018.985,919.366 1018.985,898.74 L1018.560,851.585 C1019.70,840.685 1019.876,799.484 1019.974,679.210 C1020.33,605.309 1019.71,651.717 1018.974,569.197 Z',
          mainTitleSpPic: require('../../assets/img/top/stretch--genre4_title--sp.png'),
          mainTitlePic: require('../../assets/img/top/stretch--genre4_title.png'),
          contents: [
            {
              vid: 'u3529xa1l7w',
              picSp: require('../../assets/img/top/stretch--genre4-img1--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre4-img1.jpg'),
              desc: '「合并计算」',
              thumbPic: require('../../assets/img/top/stretch--genre4-thum1.jpg')
            },
            {
              vid: 'v3529hbkmjh',
              picSp: require('../../assets/img/top/stretch--genre4-img2--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre4-img2.jpg'),
              desc: '「叠加积木」',
              thumbPic: require('../../assets/img/top/stretch--genre4-thum2.jpg')
            },
            {
              vid: 'a3529qs2wfu',
              picSp: require('../../assets/img/top/stretch--genre4-img3--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre4-img3.jpg'),
              desc: '「调整时钟」',
              thumbPic: require('../../assets/img/top/stretch--genre4-thum3.jpg')
            },
            {
              vid: 'r3529ql0iaj',
              picSp: require('../../assets/img/top/stretch--genre4-img4--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre4-img4.jpg'),
              desc: '「顺序气球」',
              thumbPic: require('../../assets/img/top/stretch--genre4-thum4.jpg')
            }
          ]
        },
        {
          bgPath:
            'M156.265,0.588 C154.884,0.588 133.382,0.11 99.309,0.12 C93.950,0.12 81.208,0.944 75.873,0.946 C43.73,0.957 21.435,0.50 16.810,0.134 C12.829,0.204 8.768,0.765 6.271,0.947 C3.1,1.185 0.343,5.134 0.343,10.299 C0.343,10.299 0.182,31.113 0.13,46.176 C0.61,52.928 0.131,77.16 0.319,92.881 C0.452,104.64 0.504,105.562 0.407,117.869 C0.351,125.80 0.343,140.984 0.343,140.984 C0.343,146.149 2.997,150.336 6.271,150.336 C8.133,150.336 13.136,150.987 14.836,150.987 C17.538,150.987 27.930,150.780 45.809,150.787 C65.472,150.794 88.593,149.924 110.435,149.919 C135.83,149.911 147.809,150.983 154.914,150.983 C157.861,150.983 163.689,150.336 165.845,150.336 C169.119,150.336 171.774,146.149 171.774,140.984 L171.937,136.169 C171.937,136.169 171.663,124.643 171.810,121.290 C171.958,117.935 171.364,99.615 171.521,81.535 C171.734,57.103 171.945,38.214 171.985,34.926 C172.40,30.330 172.59,17.537 171.774,10.299 C171.774,5.134 169.119,0.947 165.845,0.947 C163.571,0.947 157.862,0.588 156.265,0.588 Z',
          iconPic: require('../../assets/img/top/stretch--genre3_tab-icon.png'),
          titleNormalPic: require('../../assets/img/top/stretch--genre5_tab-normal.png'),
          titleActivePic: require('../../assets/img/top/stretch--genre5_tab-active.png'),
          mainBgPic: require('../../assets/img/common/bg--pattern_genre5.png'),
          mainBgPath:
            'M1018.974,569.197 C1018.879,488.358 1019.642,330.217 1019.974,264.724 C1020.441,172.709 1020.6,134.79 1019.974,127.836 C1019.752,85.295 1019.985,37.292 1019.985,37.292 C1019.985,22.198 1005.926,4.502 995.999,4.502 C995.999,4.502 957.692,2.4 907.796,2.909 C874.325,3.515 809.438,4.231 780.821,4.639 C780.536,4.617 780.255,4.572 779.967,4.572 C779.967,4.572 739.420,2.421 694.260,2.752 L591.863,3.418 L481.367,1.959 L359.931,0.500 L259.938,0.486 L127.573,0.794 L28.751,0.584 C9.371,0.584 0.0,8.656 0.928,32.289 C2.26,50.323 0.857,73.621 1.509,91.688 C2.282,113.94 1.648,179.832 1.517,202.409 C0.921,305.523 1.842,410.810 2.116,458.570 C2.483,522.855 1.334,535.597 1.333,612.174 C1.333,621.900 2.426,657.902 1.691,721.19 C1.131,768.981 0.10,894.89 0.10,894.89 C0.10,909.181 6.518,935.664 31.863,935.664 C31.863,935.664 91.932,935.617 107.970,935.617 C175.864,935.617 287.271,935.664 237.992,935.664 C237.992,935.664 263.702,935.646 286.626,935.631 C314.641,936.606 363.300,936.685 377.645,937.275 C400.812,938.227 478.983,937.597 511.59,936.695 C513.800,936.617 640.946,935.271 644.185,935.249 C676.840,936.235 710.956,935.823 727.278,936.494 C750.444,937.446 813.213,935.934 845.297,936.526 C908.859,937.691 1015.147,935.931 984.688,935.931 C1013.832,935.931 1018.985,919.366 1018.985,898.74 L1018.560,851.585 C1019.70,840.685 1019.876,799.484 1019.974,679.210 C1020.33,605.309 1019.71,651.717 1018.974,569.197 Z',
          mainTitleSpPic: require('../../assets/img/top/stretch--genre5_title--sp.png'),
          mainTitlePic: require('../../assets/img/top/stretch--genre5_title.png'),
          contents: [
            {
              vid: 'q3529666t4s',
              picSp: require('../../assets/img/top/stretch--genre5-img1--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre5-img1.jpg'),
              desc: '「分解拼图」',
              thumbPic: require('../../assets/img/top/stretch--genre5-thum1.jpg')
            },
            {
              vid: 't3529em000b',
              picSp: require('../../assets/img/top/stretch--genre5-img2--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre5-img2.jpg'),
              desc: '「旋转剪影」',
              thumbPic: require('../../assets/img/top/stretch--genre5-thum2.jpg')
            },
            {
              vid: 'c352991qo7j',
              picSp: require('../../assets/img/top/stretch--genre5-img3--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre5-img3.jpg'),
              desc: '「连接轨道」',
              thumbPic: require('../../assets/img/top/stretch--genre5-thum3.jpg')
            },
            {
              vid: 'y35290grxi8',
              picSp: require('../../assets/img/top/stretch--genre5-img4--sp.jpg'),
              pic: require('../../assets/img/top/stretch--genre5-img4.jpg'),
              desc: '「选择视角」',
              thumbPic: require('../../assets/img/top/stretch--genre5-thum4.jpg')
            }
          ]
        }
      ],
      swiperMainOption: {
        loop: false,
        longSwipesRatio: 0.45,
        threshold: 10,
        watchOverflow: true,
        spaceBetween: 180,
        speed: 750,
        on: {
          realIndexChange() {
            window.onMainSwiperChange &&
              window.onMainSwiperChange(this.realIndex);
          }
        }
        // navigation: {
        //   prevEl: '.swiper-button-prev',
        //   nextEl: '.swiper-button-next'
        // }
      },
      swiperThumbOption: {
        loop: false,
        slidesPerView: 4,
        watchSlidesProgress: true,
        multipleActiveThumbs: true,
        autoScrollOffset: 0
      }
    };
  },
  mounted() {
    if (/iPhone|iPad|iPod|Android/gi.test(navigator.userAgent)) {
    } else {
      document.querySelector('html').classList.add('is-hover');
    }
    window.txVideoPlayer = {};
    window.onMainSwiperChange = (index) => {
      this.mainSwiperChangeHandler(index);
    };
    targetDelay();
    lazyLoadImage();
    const isWeixin = checkWeixinBrowser();
    if (isWeixin) {
      // 微信浏览器自动播放视频
      document.body.addEventListener('touchstart', function () {
        const videos = [...document.getElementsByTagName('video')];
        videos.forEach((v) => {
          if (v.getAttribute('autoplay')) {
            v.play();
          }
        });
      });
    }
    this.headAnimate();
    // 气泡动画
    setInterval(() => {
      $('#jsChangeClassBgPc .type1').toggleClass('is-active');
      $('#jsChangeClassBgPc .type2').toggleClass('is-active');
    }, 7000);
  },
  methods: {
    headAnimate() {
      // 引入日方代码，从top.js拆出来的，头部动画
      const $results = $('#jsHakariAni');
      let fpsInterval;
      let now;
      let then;
      let elapsed;
      let int = 0;
      spriteAnimation();

      function startAnimating(fps) {
        fpsInterval = 1000 / fps;
        then = Date.now();
        animate();
      }

      function animate() {
        // request another frame
        window.requestAnimationFrame(animate); // calc elapsed time since last loop

        now = Date.now();
        elapsed = now - then; // if enough time has elapsed, draw the next frame

        if (elapsed > fpsInterval) {
          // Get ready for next frame by setting then=now, but also adjust for your
          // specified fpsInterval not being a multiple of RAF's interval (16.7ms)
          then = now - (elapsed % fpsInterval);
          int = int + 1; // if(int > 94){

          if (int > 167) {
            int = 1;
          }

          let name; // ゆれる

          if (int < 48) {
            $results.removeClass('type1');
            $results.removeClass('type2');
            $results.removeClass('type3');
            $results.addClass('type1');
            name = `hakari_step_${int.toString().padStart(3, '0')}`; // おじぎ
          } else if (int > 47 && int < 101) {
            $results.removeClass('type1');
            $results.removeClass('type2');
            $results.removeClass('type3');
            $results.addClass('type2');
            let num = int;

            if (int > 74) {
              num = 74 - (num - 74);
            }

            name = `hakari_step_${num.toString().padStart(3, '0')}`; // ゆれる
          } else if (int > 100 && int < 149) {
            $results.removeClass('type1');
            $results.removeClass('type2');
            $results.removeClass('type3');
            $results.addClass('type1');
            const _num = int;
            name = `hakari_step_${(_num - 100).toString().padStart(3, '0')}`; // うなずく(76-94)
          } else {
            $results.removeClass('type1');
            $results.removeClass('type2');
            $results.removeClass('type3');
            $results.addClass('type3');
            const _num2 = int;
            name = `hakari_step_${(_num2 - 73).toString().padStart(3, '0')}`;
          }

          $results.removeClass(function (index, className) {
            return (className.match(/\bhakari_step_\S+/g) || []).join(' ');
          });
          $results.addClass(name);
        }
      }

      function spriteAnimation() {
        const images = [];
        const img = new Image();
        img.src = require('../../assets/img/top/mv--hakari_sprite1.png');
        images.push(img);

        images[0].onload = function () {
          startAnimating(30);
        };
      }

      setTimeout(() => {
        $('#jsChangeClassBgPc .type1').toggleClass('is-active');
      }, 1000);
    },
    playVideo(id) {
      setTimeout(() => {
        window.txVideoPlayer &&
          window.txVideoPlayer[id] &&
          window.txVideoPlayer[id].play();
      });
      this.currentPlaying = id;
    },
    swiperPrev(index) {
      const swiper = this.$refs[`mainSwiper${index + 1}`];
      swiper && swiper[0].swiper.slidePrev();
    },
    swiperNext(index) {
      const swiper = this.$refs[`mainSwiper${index + 1}`];
      swiper && swiper[0].swiper.slideNext();
    },
    tabClickHandler(index) {
      if (this.currentTab !== index) {
        this.currentTab = index;
        this.currentMainIndex = 0;
        this.pauseVideo(this.currentPlaying);
        this.thumbSwiperChangeHandler(this.currentTab, this.currentMainIndex);
      }
    },
    mainSwiperChangeHandler(index) {
      this.currentMainIndex = index;
      this.pauseVideo(this.currentPlaying);
    },
    thumbSwiperChangeHandler(swiperIndex, slideIndex) {
      const swiper = this.$refs[`mainSwiper${swiperIndex + 1}`];
      swiper && swiper[0].swiper.slideTo(slideIndex);
    },
    pauseVideo(id) {
      // 停止播放
      setTimeout(() => {
        window.txVideoPlayer &&
          window.txVideoPlayer[id] &&
          window.txVideoPlayer[id].pause();
      });
    }
  }
};
</script>
<style>
.yt .inline_video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.swiper-overflow-visible {
  overflow: visible;
}
</style>
